/* eslint-disable react/no-unused-prop-types */
import React, { PropTypes, Component } from 'react';
import Highcharts from 'highcharts';
import _ from 'lodash';
import message from '../message';

/**
 * Use Highcharts to create charts in React
 * http://www.highcharts.com/blog/192-use-highcharts-to-create-charts-in-react
 */
export default class Chart extends Component {
  constructor(props) {
    super(props);

    // Highchartsの初期設定
    Highcharts.setOptions({
      global: {
        // GMTではなくJSTを使う
        useUTC: false,
      },
      lang: {
        months: message.months,
        // 桁区切りを表示しない
        thousandsSep: '',
      },

      // exportingを出さない
      exporting: {
        enabled: false,
      },
      credits: {
        enabled: false,
      },
    });
  }

  // When the DOM is ready, create the chart.
  componentDidMount() {
    this.renderChart(this.props);
  }

  shouldComponentUpdate(nextProps) {
    if (_.isEqual(this.props, nextProps)) {
      // propsが全く同じであれば、renderChartを呼ばずに普通通りにtrueを返す
      return true;
    }

    this.renderChart(nextProps);
    // renderChartでグラフを書き直しているので、react側のrenderは呼ばない
    return false;
  }

  // Destroy chart before unmount.
  componentWillUnmount() {
    this.chart.destroy();
  }

  renderChart({ modules, type, options }) {
    // Extend Highcharts with modules
    if (modules) {
      modules.forEach((module) => {
        module(Highcharts);
      });
    }

    /**
     * new Highcharts(options)によって、options自体が書き換えられてしまう。
     * this.props.optionsを書き換えたくないので、deepcopyをとってnew Highcharts()に渡す。
     */
    const deepcopyOptions = _.cloneDeep(options);
    const chartOption = deepcopyOptions.chart;

    // Set container which the chart should render to.
    this.chart = new Highcharts[type]({
      ...deepcopyOptions,
      chart: {
        ...chartOption,
        renderTo: this.chartNode,
      },
    });
  }

  // Create the div which the chart will be rendered to.
  render() {
    return (
      <div
        ref={(ref) => {
          this.chartNode = ref;
        }}
      />
    );
  }
}

Chart.propTypes = {
  modules: PropTypes.array,
  type: PropTypes.string,
  options: PropTypes.object.isRequired,
};

Chart.defaultProps = {
  modules: [],
  type: 'Chart',
};



// WEBPACK FOOTER //
// ./es6/utils/components/Chart.js